// extracted by mini-css-extract-plugin
export default {"section":"SummaryHeader_section__g-b7p","container":"SummaryHeader_container__5PBKl"};